var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5499 4.16523L7.47217 1.6421V6.65957L5.5499 4.16523ZM3.07292 4.59252L3.74795 5.47779C3.85389 5.61377 3.99202 5.69592 4.14297 5.69592H4.14828H4.15234C4.3036 5.69592 4.44173 5.6133 4.54892 5.47637L4.54799 5.47732L5.22301 4.59205L7.27497 7.25447H1.0219L3.07292 4.59252ZM1.01909 1.04389H7.27872L4.27204 4.98912C4.23823 5.02952 4.19638 5.05148 4.15328 5.05144H4.14891H4.14484C4.10159 5.05153 4.0596 5.02938 4.02578 4.98865L4.02609 4.98912L1.01909 1.04389ZM0.825018 1.64162L2.74697 4.16476L0.825018 6.65768V1.64162ZM7.5753 0.489121C7.5003 0.432464 7.41217 0.399414 7.31873 0.399414H0.979399C0.888821 0.399447 0.799487 0.431289 0.718451 0.492426L0.721888 0.490066C0.624876 0.562356 0.543177 0.674192 0.486021 0.812939C0.428864 0.951686 0.398527 1.11182 0.398438 1.27524V7.02217C0.398603 7.25475 0.459831 7.47774 0.568688 7.6422C0.677545 7.80666 0.82514 7.89916 0.979087 7.89941H7.31779C7.47174 7.89916 7.61933 7.80666 7.72819 7.6422C7.83704 7.47774 7.89827 7.25475 7.89844 7.02217V1.27524C7.89844 0.931992 7.76749 0.634542 7.57686 0.491482L7.57342 0.489121H7.5753Z",
    fill: "#04236B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.9ba5bf1a4b015cf172d661b852f4b0e7.svg";
export { ForwardRef as ReactComponent };